function showToast(message, duration = 2000) {
    const toast = document.createElement("div");
    toast.textContent = message;
    
    // Styling for top-center position
    toast.style.position = "fixed";
    toast.style.top = "20px";
    toast.style.left = "50%";
    toast.style.transform = "translateX(-50%)";
    toast.style.padding = "10px 20px";
    toast.style.background = "black";
    toast.style.color = "white";
    toast.style.borderRadius = "5px";
    toast.style.zIndex = "9999";
    toast.style.boxShadow = "0px 4px 6px rgba(0,0,0,0.1)";
    toast.style.fontSize = "16px";
    toast.style.fontWeight = "bold";
    toast.style.textAlign = "center";
    toast.style.opacity = "1";
    toast.style.transition = "opacity 0.5s ease-in-out";
    
    document.body.appendChild(toast);

    // Remove after duration
    setTimeout(() => {
        toast.style.opacity = "0";
        setTimeout(() => toast.remove(), 500); // Wait for fade-out effect
    }, duration);
}

export default showToast